export const convertItemForFilter = (obj) => {
  let items = Object.values(obj).map((val) => val);
  return items;
};
